import React, {Component} from "react";
import {connect} from 'react-redux';
import FJToolbarCommon from "../view/FJToolbarCommon";
import classNames from "classnames";
import FJColorContainer from "../view/FJColorContainer";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJLocalStore from "../../../store/FJLocalStore";
import FJConfig from "../../../config/FJConfig";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJTransform from "../view/FJTransform";
import FJTransparency from "../view/FJTransparency";

class FJToolbarWidgetContainer extends Component {

	/**
	 * @description 小组件颜色设置
	 * @param type
	 * @param color
	 * @param index
	 * @private
	 */
	_widgetColorChanged = (type, color, index) => {
		let {colors, widgetColorChanged} = this.props;
		let newColors = [...colors];
		newColors.splice(index, 1, color.mainColor);
		widgetColorChanged(type, newColors);
	};

	render() {
		const {
			documentColors,
			addDocumentColor,
			deleteColor,
			disabled,
			colors,
			active,
			opacityValue,
			opacityChange,
			hasFlip,
			hasOpacity,
		} = this.props;

		// 颜色个数大于maxSupportColors个则不显示
		let _colors = colors.length > FJConfig.maxSupportColors ? [] : colors;

		return (
			<FJToolbarCommon className={classNames('c-toolbar-text', {active: active})}>
				{
					_colors.map((color, index) => {
						return (<FJColorContainer hasApplyToAll={false}
						                          disabled={disabled}
                                      useAnchorBody
                                      isTopLayer
						                          documentColors={documentColors}
						                          addDocumentColor={addDocumentColor}
						                          deleteColor={deleteColor}
						                          isSolid={true}
						                          colorData={{mainColor: color}}
						                          colorDataChange={(type, color) => {
							                          this._widgetColorChanged(type, color, index)
						                          }}
						                          tips={FJLocalStore._('shape-color')}
						                          key={index}
						/>);
					})
				}
				{
					hasFlip ?
						<>
              {_colors.length === 0 ? null :<FJToolbarDevider/>}
							<FJTransform type='element'/>
						</> : null
				}
				{
					hasOpacity ?
						<>
							<FJToolbarDevider/>
							<FJTransparency opacityValue={opacityValue}
							                opacityChange={opacityChange}
							/>
						</> : null
				}
			</FJToolbarCommon>
		)
	}
}

const mapStateToProps = function (state) {
	return {
		documentColors: state.documentColor.documentColors,
		colors: state.toolWidget.colors,
		opacityValue: state.toolbar.opacityValue
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		widgetColorChanged: function (type, colors) {
			dispatch(FJToolbarAction.setWidgetColorAction(type, colors));
		},
		addDocumentColor: function (type, color) {
			dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
		},
		deleteColor: function (type, index) {
			dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
		},
		opacityChange: function (type, value) {
			dispatch(FJToolbarAction.changeOpacityValueAction(type, value))
		}
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarWidgetContainer);